var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable } from 'mobx';
import { MunsellMetric } from '@cutwise/color-visualizer';
import { ProductType } from '@/product/constants/productTypes';
import Product from '@/product/entity/Product';
export default class Gem extends Product {
    entityType = ProductType.Gem;
    gemType;
    fancyColorGrade;
    constructor(modelData) {
        super(modelData);
        this.gemType = modelData.gemType;
        if (modelData._embedded?.scores?.hue && MunsellMetric.isValidMetric(modelData._embedded.scores.hue)) {
            this.fancyColorGrade = new MunsellMetric(modelData._embedded.scores.hue);
        }
    }
}
__decorate([
    observable
], Gem.prototype, "gemType", void 0);
__decorate([
    observable.ref
], Gem.prototype, "fancyColorGrade", void 0);
